import { lazy, memo, Suspense } from 'react';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';
import { useWindowIsTabletOrMobile } from '@liveauctioneers/hammer-ui-core/providers';

const HowToWinMobilePage = lazy(() => import('@/pages/HowToWin/HowToWinMobile/HowToWinMobilePage'));
const HowToWinDesktopPage = lazy(() => import('@/pages/HowToWin/HowToWinDesktop/HowToWinDesktopPage'));

const HowToWinPage = () => {
    const isTabletOrMobile = useWindowIsTabletOrMobile();

    const Page = isTabletOrMobile ? HowToWinMobilePage : HowToWinDesktopPage;

    return (
        <Suspense fallback={<Loading />}>
            <Page />
        </Suspense>
    );
};

export default memo(HowToWinPage);
